import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PreventClosePopinComponent } from '../components/prevent-close-popin/prevent-close-popin.component';
import { SellerPaymentPageComponent } from '../seller-payment-page.component';

@Injectable({ providedIn: 'root' })
export class PendingFormGuard implements CanDeactivate<SellerPaymentPageComponent> {
  constructor(private dialog: MatDialog) {}
  canDeactivate(
    component: SellerPaymentPageComponent,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!component.selectedForm) {
      return true;
    }

    return this.dialog
      .open(PreventClosePopinComponent, {
        disableClose: false,
        width: '600px',
        height: 'auto'
      })
      .afterClosed();
  }
}
